import { supabase, isSupabaseConfigured } from './supabase';

/**
 * Kursdaten, die im Admin-Dashboard gepflegt werden und auf der
 * öffentlichen Website (Startseite + Anmeldeseite) angezeigt werden.
 * Liefert null, wenn Supabase nicht erreichbar/konfiguriert ist —
 * die Seiten fallen dann auf ihre eingebauten Inhalte zurück.
 */
export interface WebsiteCourse {
  id: string;
  level: string;
  title: string;
  subtitle: string | null;
  description: string;
  duration: string;
  sessions: string;
  frequency: string | null;
  books: string[];
  skills: string[];
  image_url: string | null;
  start_label: string | null;
  price_monthly: number;
  price_full: number;
  is_active: boolean;
  max_participants: number;
}

let cache: WebsiteCourse[] | null = null;

export async function fetchWebsiteCourses(): Promise<WebsiteCourse[] | null> {
  if (!isSupabaseConfigured) return null;
  if (cache) return cache;
  try {
    const { data, error } = await supabase
      .from('courses')
      .select('*')
      .eq('is_active', true)
      .order('level', { ascending: true });
    if (error || !data || data.length === 0) return null;
    cache = data as WebsiteCourse[];
    return cache;
  } catch {
    return null;
  }
}
